import React from 'react';

function Footer() {
  return (
    <footer className="relative mt-auto">
      <div className="relative z-10 py-8">
        <div className="flex flex-col items-center gap-6 max-w-xl mx-auto px-4">
          
          {/* Contact section */}
          <div className="flex items-center gap-2 text-sm">
            <span className="text-gray-400">Investor?</span>
            <a 
              href="mailto:team@rezonata.xyz" 
              className="text-white hover:text-gray-300 transition-colors duration-300"
            >
              team@rezonata.xyz
            </a>
          </div>
          
          {/* Copyright */}
          <div className="text-center">
            <a
              href="https://rezonata.xyz"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-white transition-colors duration-300"
            >
              Rezonata
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;